/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Hook_Returning_User_ActionInputs */

const en_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I already have an account`)
};

const de_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe bereits ein Konto`)
};

const pt_br2_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tenho uma conta`)
};

const tr_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten bir hesabım var`)
};

const zh_cn2_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我已有账户`)
};

const zh_hk2_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我已有帳戶`)
};

const ko_kr2_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있어요`)
};

const ru_ru2_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У меня уже есть аккаунт`)
};

const es_419_onboarding_v1_hook_returning_user_action = /** @type {(inputs: Onboarding_V1_Hook_Returning_User_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tengo una cuenta`)
};

/**
* | output |
* | --- |
* | "I already have an account" |
*
* @param {Onboarding_V1_Hook_Returning_User_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_hook_returning_user_action = /** @type {((inputs?: Onboarding_V1_Hook_Returning_User_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Hook_Returning_User_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "de") return de_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_hook_returning_user_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_hook_returning_user_action(inputs)
	return es_419_onboarding_v1_hook_returning_user_action(inputs)
});